import React from "react";
import styled from "styled-components";
import header from "./header.jpg";
import HomeBrand from "./HomeBrand";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone } from "@fortawesome/fontawesome-free-solid";
import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import {
  faF,
  faKiwiBird,
  faG,
  faCamera,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";

const Home = () => {
  return (
    <HomeWrapper id="home">
      <HomeTitle>We Make Responsive Design </HomeTitle>
      <HomeTitleButton>Learn More</HomeTitleButton>
      <RestHome>
        <RestLeft>
          <h6>Are locking for</h6>
          <h5>Lorem inpsum</h5>
          <h6>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</h6>
        </RestLeft>
        <RestRight>
          <RestRightLeft>
            <h6>
              <FontAwesomeIcon icon={faMicrophone} /> <></>(123) 456-7890
            </h6>
            <h6>
              <FontAwesomeIcon icon={faMailBulk} /> <></>info@domain.com
            </h6>
          </RestRightLeft>
          <RestRightLeft>
            <h6>Social Media</h6>
            <h6>
              <FontAwesomeIcon icon={faF} /> <></>
              <FontAwesomeIcon icon={faKiwiBird} /> <></>
              <FontAwesomeIcon icon={faG} /> <></>
              <FontAwesomeIcon icon={faCamera} /> <></>
              <FontAwesomeIcon icon={faWifi} /> <></>
            </h6>
          </RestRightLeft>
        </RestRight>
      </RestHome>
    </HomeWrapper>
  );
};

const HomeWrapper = styled.div`
  width: 100vw;
  height: 104vh;
  overflow: hidden;
  scroll-behavior: smooth;

  background: linear-gradient(rgba(47, 61, 74, 0.9), rgba(47, 61, 74, 0.9)),
    url(${header});
  background-size: cover;
`;

const HomeTitle = styled.h1`
  max-width: 45vw;
  color: white;
  font-size: 5vw;
  margin-left: 11vw;
  margin-top: 15vw;

  @media screen and (orientation: portrait) {
    max-width: 80vw;
    font-size: 6.5vh;
    margin-left: 10vw;
    margin-top: 25vh;
  }
`;

const HomeTitleButton = styled.button`
  margin-left: 11vw;
  color: white;
  border: none;
  background-color: #f53b4d;
  width: 8vw;
  height: 2.5vw;
  border-radius: 50px;
  font-size: 1vw;
  cursor: pointer;

  @media screen and (orientation: portrait) {
    margin-left: 10vw;
    margin-top: 2.5vh;
    width: 18vh;
    height: 5vh;
    font-size: 2vh;
  }
`;

const RestHome = styled.div`
  width: 80vw;
  height: 15vh;
  margin-top: 15vh;
  margin-left: 10vw;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);

  @media screen and (orientation: portrait) {
    width: 95vw;
    margin-left: 2.5vw;
    height: 20vh;
    margin-top: 13vh;

    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
`;

const RestLeft = styled.div`
  h6 {
    margin: 0;
    margin-left: 1vw;
    color: white;
    font-size: 1vw;
    font-weight: 300;

    @media screen and (orientation: portrait) {
      font-size: 1.7vh;
      margin-left: 5vw;
    }
  }

  h5 {
    margin: 0;
    margin-left: 1vw;
    color: white;
    font-size: 1.5vw;
    font-weight: 500;

    @media screen and (orientation: portrait) {
      font-size: 2.6vh;
      margin-left: 5vw;
    }
  }
`;

const RestRight = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);

  align-items: center;
`;

const RestRightLeft = styled.div`
  h6 {
    margin: 0;
    margin-left: 1vw;
    color: white;
    font-size: 1vw;
    font-weight: 300;
    text-align: right;

    @media screen and (orientation: portrait) {
      font-size: 2vh;
      margin-right: 5vw;
    }
  }
`;
export default Home;
